import React, { Component } from 'react';

export default class Chapter1 extends Component {
  render() {
    return (
      <div>
        <div className="medium-padding joysetter-header">
          <h6 className="white">Jet Lag Tool Kit</h6>
          <h1 className="white">Chapter 3: Into the Storm</h1>
          <p className="white"><b>How to dance in the storm (even if you have no rhythm)</b></p>
        </div>
        <div className="toolkit-content">
          <ol >
            <li>Look back on your past and some of the most difficult storms that you have faced. Breathe deeply through the discomfort that comes up. Observe the storms with curiosity and without placing blame.
            </li>
            <li>Reflect on the gifts and growth that they have provided you with. Find the value and benefit in the suffering. Search for the skills, the lessons, and the gifts that it gave you.
            </li>
            <li>Accept the storm as reality. Give thanks to it for what it has taught you and appreciate that it led you to where you are right now.
            </li>
            <li>When new storms arise and the winds begin to howl, think of the Redwood and choose to accept and appreciate the nature of the storm as a gift for you and your growth. Move with it, not against it. Remember that it will pass and until it does, just try to enjoy the ride.
            </li>
          </ol>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/toolkits/chapter3.js